import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-angular-simple-lib',
  template: `
    <p>
      Hello world!
    </p>
  `,
  styles: [
  ]
})
export class AngularSimpleLibComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
